import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { StorageManagerService, AuthorizationService, SettingsService, CustomerService } from '../../../shared/services/index';
import { ICustomer, IHasPermissionObject } from '../../../shared/models/index';
import { Subscription, Observable, BehaviorSubject, throwError } from 'rxjs';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { CustomerSelectorComponent, NavMenuComponent, FooterComponent } from '../../index';
import { EmitType } from '@syncfusion/ej2-base';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { SessionTimeoutService } from '../../../shared/services/session-timeout.service';
import { AbsoluteSessionTimeoutService } from '../../../shared/services/session-timeout-absolute.service';
import { Router, NavigationEnd, NavigationCancel, NavigationError, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Utilities } from '../../../shared/services/utilities';
import { OrderTrackerComponent } from '../../order-tracker/order-tracker.component';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.scss']
})
export class SiteLayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  position: object = { X: 'center', Y: 'center' };
  modalWidth = '25%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  sessionExpireSecondsLeft: number;
  hidden = false;

  title = 'app';
  isIframe: boolean;
  lastLogonDate: string;
  hasPermission: boolean;
  isLoggedIn: boolean;
  hasCurrentCustomer: boolean;
  userName: string;
  permissionsSet: string[];
  selectedCustomer: string;
  subscription: Subscription;
  currentCustomer: ICustomer;
  email: string;
  loggedIn = false;
  customerId: number;
  userGuid: string;
  customers: ICustomer[] = [];
  eligibleCustomers: any[] = [];
  bHasOnlyOneClient = false;
  dataScope: string;
  dataSourceApi: any;
  dataScopeId: number;
  dataSource: any[] = [];
  private applicationName = 'SSDrugProducts';
  private applicationId = 269;
  applications: any[] = [];
  absoluteSessionExpireMinutesLeft: number;
  bnccUrl = '';

  @ViewChild('customerSelector')
  customerSelector: CustomerSelectorComponent;

  @ViewChild('navMenu')
  navMenuComponent: NavMenuComponent;

  @ViewChild('footer')
  footerComponent: FooterComponent;

  @ViewChild('sessionTimeoutModal')
  public sessionTimeoutModal: DialogComponent;

  @ViewChild('absoluteSessionTimeoutModal')
  public absoluteSessionTimeoutModal: DialogComponent;

  hasPermissionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  lastLogonDateSourceSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  orderTrackerComponent: OrderTrackerComponent;
  dataScopeName: any;
  loading: boolean;
  isOnLogin: boolean;

  constructor(private authorizationService: AuthorizationService, private storageManagerService: StorageManagerService,
    private authenticationService: AuthenticationService, private customerService: CustomerService, private router: Router,
    private sessionTimeoutservice: SessionTimeoutService, private cdRef: ChangeDetectorRef, private absoluteSessionTimeoutService: AbsoluteSessionTimeoutService,
    private utilService: Utilities, private settingsService: SettingsService) {

    //  This is to avoid reload during acquireTokenSilent() because of hidden iframe
    this.isIframe = window !== window.parent && !window.opener;

    // Handle the browser refresh
    if (this.storageManagerService.read('lastLogonDate')) {
      this.lastLogonDate = this.storageManagerService.read('lastLogonDate');
      this.authorizationService.lastLogonDateSourceSubject.next(this.lastLogonDate);
    }

    if (this.storageManagerService.read('hasPermission')) {
      this.hasPermission = this.storageManagerService.read('hasPermission');
      this.authorizationService.hasPermissionSubject.next(this.hasPermission);
    }

    if (this.storageManagerService.read('accessPermissions')) {
      this.permissionsSet = this.storageManagerService.read('accessPermissions');
      this.authorizationService.permissionsSetSubject.next(this.permissionsSet);
    }

    router.events
      .subscribe((routerEvent: NavigationEvent) => {
        if (routerEvent instanceof NavigationStart) {

          this.loading = true;
        }
        if (routerEvent instanceof NavigationEnd ||
          routerEvent instanceof NavigationCancel ||
          routerEvent instanceof NavigationError) {

          this.loading = false;
        }
      });
  }

  onActivate(componentRef) {

    if (componentRef instanceof OrderTrackerComponent) {
      this.orderTrackerComponent = componentRef;
    }
  }

  ngOnInit() { }

  authenticateUsersWithCustomers(userData: any) {

    const cust = this.storageManagerService.read('currentCustomer');

    if (cust) {
      this.currentCustomer = typeof cust === 'object' ? cust : JSON.parse(cust);

      this.authenticationService.initPendo(userData.userguid, this.currentCustomer.customerName);
    }

    this.userName = userData.name;
    this.email = userData.preferred_username;

    if (userData.applications) {
      this.applications = JSON.parse(userData.applications);
    }

    if (this.orderTrackerComponent) {
      this.orderTrackerComponent.loadInitialToolbar();
      this.orderTrackerComponent.loadData();
    }

    if (this.applications && this.applications.length > 0 && this.applications[0].AName === this.applicationName) {

      if (!this.storageManagerService.read('userGuid')) {

        this.authorizationService.getPermisions(userData.preferred_username)
          .subscribe((res: IHasPermissionObject) => {

            const hasApplicationPermissions = res.hasApplicationPermissions;

            this.hasPermissionSubject.next(hasApplicationPermissions);
            this.hasPermission = hasApplicationPermissions;
            this.authorizationService.hasPermissionSubject.next(this.hasPermission);

            this.storageManagerService.write('hasPermission', hasApplicationPermissions);

            this.lastLogonDateSourceSubject.next(userData.lastlogondate);
            this.storageManagerService.write('lastLogonDate', userData.lastlogondate);

            this.storageManagerService.write('userGuid', res.userGuid);

            if (!hasApplicationPermissions) {

              this.router.navigate(['/accessdenied']).then(() => {
                return;
              });
            }
          });
      } else {

        if (!this.permissionsSet) {

          if (this.currentCustomer) {

            const user = this.storageManagerService.read('userData');

            if (user && user !== '""') {

              const userName = user.preferred_username;

              this.authorizationService.setAccessPermissions(userName).subscribe(res => {
                this.permissionsSet = res;

                this.authorizationService.permissionsSetSubject.next(res);
                this.storageManagerService.write('accessPermissions', this.permissionsSet);

                if (this.navMenuComponent) {
                  this.navMenuComponent.permissionsSet = this.permissionsSet;
                  // this.navMenuComponent.uploadFilesMenu = this.authorizationService.hasPermission('SS.CanUploadFile');
                  this.manageNavMenuAccess();
                }
              });
            }
          } else {

            this.eligibleCustomers = this.storageManagerService.read('eligibleCustomers', []);

            if (this.eligibleCustomers && this.eligibleCustomers.length > 0) {
              this.customers = this.eligibleCustomers;
            }
          }
        } else {
          if (this.navMenuComponent) {
            this.navMenuComponent.permissionsSet = this.permissionsSet;
            // this.navMenuComponent.uploadFilesMenu = this.authorizationService.hasPermission('SS.CanUploadFile');
            this.manageNavMenuAccess();

            this.authorizationService.permissionsSetSubject.next(this.permissionsSet);
            this.storageManagerService.write('accessPermissions', this.permissionsSet);
          }
        }
      }

      this.subscription = this.authenticationService.getIsAuthorized().subscribe(
        (isAuthorized: boolean) => {
          if (isAuthorized) {
            this.absoluteSessionTimeoutService.reset();
          }
          if (this.navMenuComponent) {
            this.navMenuComponent.loggedIn = isAuthorized;
          }
        });

      this.subscription = this.authorizationService.hasPermissionSubject.subscribe((res) => {
        this.hasPermission = res;
      });

      this.lastLogonDate = this.storageManagerService.read('lastLogonDate');

      if (!this.lastLogonDate) {

        this.subscription = this.lastLogonDateSourceSubject.subscribe(res => {
          this.lastLogonDate = res;

        });
      }
      // Session Time out
      this.sessionTimeoutservice.sessionTimeoutWarning.subscribe(time => {
        this.sessionExpireSecondsLeft = time / 1000;
        this.displaySessionExpireWarning();
      });
      this.sessionTimeoutservice.reset();

      // Absolute Session
      this.absoluteSessionTimeoutService.sessionTimeoutWarning.subscribe(time => {
        this.absoluteSessionExpireMinutesLeft = time / 60000;
        this.displayAbsoluteSessionExpireWarning();
      });
    } else {
      this.router.navigate(['/accessdenied']);
    }
  }

  getCustomersWithResponse(userData: any) {
    return this.getCustomers(userData.userguid).subscribe(async data => {

      this.customers = data;

      if (this.storageManagerService.read('eligibleCustomers', []).length === 0) {
        if (this.customers && this.customers.length > 0) {

          for (let cu of this.customers) {
            const c = {};
            c['customerId'] = cu['customerId'];
            c['customerGuid'] = cu['customerGuid'];
            c['customerName'] = cu['customerName'];
            c['subscribedChannels'] = await this.customerService.getCustomerAppVariants(cu['customerId'], this.applicationId);

            // Only push items into the array if they don't already exist in it
            if (this.eligibleCustomers.length === 0 || this.eligibleCustomers.findIndex(x => x.customerId === c['customerId']) === -1) {
              this.eligibleCustomers.push(c);
            }
          }

          this.eligibleCustomers.sort((x, y) => (x.customerName.toLowerCase() > y.customerName.toLowerCase()) ? 1 : ((x.customerName.toLowerCase() < y.customerName.toLowerCase()) ? -1 : 0));

          this.storageManagerService.write('eligibleCustomers', this.eligibleCustomers);

          if (this.customers.length === 1) {

            this.storageManagerService.write('currentCustomer', this.eligibleCustomers[0]);
            this.bHasOnlyOneClient = true;
            if (userData.preferred_username) {
              this.authorizationService.setAccessPermissions(userData.preferred_username).subscribe(res => {

                if (res) {

                  this.storageManagerService.write('accessPermissions', res);
                  this.authorizationService.permissionsSetSubject.next(res);

                  if (this.navMenuComponent) {

                    this.navMenuComponent.hasCurrentCustomer = true;
                    this.navMenuComponent.selectedCustomer = this.selectedCustomer;
                    this.navMenuComponent.customers = this.eligibleCustomers;
                    this.navMenuComponent.switchCustomersddw.value = this.currentCustomer.customerId;

                    this.navMenuComponent.permissionsSet = res;
                    // this.navMenuComponent.uploadFilesMenu = this.authorizationService.hasPermission('SS.CanUploadFile');
                    this.manageNavMenuAccess();
                  }
                }
              });
            }

            this.customers = this.eligibleCustomers[0].customerId;
            this.currentCustomer = this.eligibleCustomers[0];
            if (this.navMenuComponent) {
              this.navMenuComponent.hasCurrentCustomer = true;
              this.navMenuComponent.selectedCustomer = this.eligibleCustomers[0].customerName;
            }
          }
        }
      }


      if (this.currentCustomer) {
        this.authorizationService.setAccessPermissions(userData.preferred_username).subscribe(res => {

          this.permissionsSet = res;

          this.authorizationService.permissionsSetSubject.next(res);
          this.storageManagerService.write('accessPermissions', this.permissionsSet);

          if (this.navMenuComponent) {
            this.navMenuComponent.permissionsSet = this.permissionsSet;
            // this.navMenuComponent.uploadFilesMenu = this.authorizationService.hasPermission('SS.CanUploadFile');
            this.manageNavMenuAccess();
          }
        });
      } else {

        this.customers = this.eligibleCustomers;

        if (this.customers && this.customers.length === 0) {

          this.router.navigate(['/accessdenied']);
        }
      }

      this.authenticateUsersWithCustomers(userData);
    }, error => { this.handleError(error) });
  }

  ngAfterViewInit(): void {
    let userData = this.storageManagerService.read('userData');
    if (userData) {
      this.getCustomersCallback(userData, this);
    }

    this.cdRef.detectChanges();
  }

  // authentication service can't pull a bearer token on the first pass, need to wait
  getCustomersCallback(userData: any, that: any) {
    // Need this where it's the app component form and not this where it's the setTimeout local this
    if (!that) {
      that = this;
    }

    if (!that.authenticationService || that.authenticationService.getBearerToken() === '') {
      setTimeout(that.getCustomersCallback, 50, userData, that);
    } else {
      // If on first login don't display the pop-up
      that.isOnLogin = (!that.storageManagerService.read('currentCustomer'));
      that.subscription = that.getCustomersWithResponse(userData);
    }
  }

  displaySessionExpireWarning() {

    this.sessionTimeoutModal.show();
  }

  displayAbsoluteSessionExpireWarning() {
    this.absoluteSessionTimeoutModal.show();
  }

  public onAbsoluteContinueClicked(event) {
    this.absoluteSessionTimeoutModal.hide();
  }

  dlgAbsoluteSessionTimeoutButtons: Object[] = [{
    click: this.onAbsoluteContinueClicked.bind(this), buttonModel: { content: 'OK', isPrimary: true }
  }];

  getCustomers(userGuid: string): Observable<ICustomer[]> {
    const paramsContainer = {
      applicationName: this.applicationName,
      userGuid: userGuid
    };

    return this.customerService.getCustomers(paramsContainer);
  }

  changeDataScope(dataScope: any) {

    this.dataScopeName = dataScope['name'];
  }

  receiveCustomer(customer: any) {
    this.dataSourceApi = [];

    let oldCustomer;
    if (this.storageManagerService.read('currentCustomer')) {
      // For scenarios where the user only has a single customer the 'currentCustomer' is already an object
      // so attmepts to run JSON.parse on it will fail due to 'currentCustomer' not being a valid JSON string.
      oldCustomer = typeof this.storageManagerService.read('currentCustomer') !== "object"
        ? JSON.parse(this.storageManagerService.read('currentCustomer'))
        : this.storageManagerService.read('currentCustomer');
    }

    this.currentCustomer = customer;
    this.selectedCustomer = customer.customerName;

    this.storageManagerService.write(
      'currentCustomer', JSON.stringify(customer));

    this.authenticationService.reviveToken();

    // Get DataScopes and pass to NavMenu
    if (this.storageManagerService.read('userData').preferred_username) {
      this.authorizationService.setAccessPermissions(this.storageManagerService.read('userData').preferred_username).subscribe(res => {

        if (res) {

          this.storageManagerService.write('accessPermissions', res);
          this.authorizationService.permissionsSetSubject.next(this.permissionsSet);

          if (this.navMenuComponent) {

            if (!this.eligibleCustomers || this.eligibleCustomers.length === 0) {
              this.eligibleCustomers = this.storageManagerService.read('eligibleCustomers', []);
            }

            this.navMenuComponent.customers = this.eligibleCustomers;

            this.navMenuComponent.hasCurrentCustomer = true;
            this.navMenuComponent.selectedCustomer = this.selectedCustomer;
            this.navMenuComponent.switchCustomersddw.value = this.currentCustomer.customerId;

            this.navMenuComponent.permissionsSet = res;
            // this.navMenuComponent.uploadFilesMenu = this.authorizationService.hasPermission('SS.CanUploadFile');
            this.manageNavMenuAccess();
          }

          if (this.orderTrackerComponent) {
            this.orderTrackerComponent.loadInitialToolbar();
            this.orderTrackerComponent.loadData();
          }

          let currentUrl = '';
          if (this.router && this.router.url) {
            currentUrl = this.router.url;
          }

          // Sometimes the URL has a "#" then a bunch of tokens, strip off those.
          if (currentUrl.indexOf('#') > -1) {
            currentUrl = currentUrl.substring(0, currentUrl.indexOf('#'));
          }

          // Remove any numbers from the end of the URL, to catch pages with ID's for example: /product/dashboard/123
          let numberStartIndex = currentUrl.slice(0).search(/\d/);
          if (numberStartIndex > -1) {
            currentUrl = currentUrl.substring(0, numberStartIndex - 1);
          }

          // a user with only the two permissions SSDP.CanValidateSPL-HC SSDP.CanValidateSPL-FDA is the validation specialist role
          const validationSpecialist = res.length === 2 && this.navMenuComponent.hcValidationFormMenu;
          this.navMenuComponent.defaultHomepageLink = validationSpecialist ? '/health-canada-spl-validation' : '/order-tracker';

          if (validationSpecialist && currentUrl !== '/health-canada-spl-validation') {
            return this.router.navigateByUrl('/health-canada-spl-validation');
          }
         
          if (currentUrl.includes('/bncc')) {
            if (this.navMenuComponent.editBNCCFormMenu) {
              if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                window.location.reload();
              }
            } else {
              this.bnccUrl = currentUrl
              this.router.navigateByUrl('/accessdenied');
            }
          }

          if (this.bnccUrl != '' && currentUrl.includes('/accessdenied')) {
            if (this.bnccUrl.includes('/bncc/form') || this.bnccUrl.includes('/bncc/create-step')) {
              this.router.navigateByUrl('/bncc');
            } else {
              this.router.navigateByUrl(this.bnccUrl);
            }
          }
         
          switch (currentUrl) {

            case '/company-dashboard':

              if (this.navMenuComponent.editCompanyMenu) {

                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/contact-dashboard':

              if (this.navMenuComponent.editContactMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/products/portfolio':
              if (this.navMenuComponent.editLLFormMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            // If you're on a dashboard need to re-direct back up one level
            case '/products/dashboard':
              if (this.navMenuComponent.editLLFormMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  this.router.navigateByUrl('/products/portfolio')
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/lcr-form-dashboard':

              if (this.navMenuComponent.editLCRFormMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/er-form-dashboard':

              if (this.navMenuComponent.editERFormMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/submission-dashboard':

              if (this.navMenuComponent.submissionMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {
                this.router.navigateByUrl('/accessdenied');
              }
              break;
            case '/order-tracker':
            case 'order':

              if (this.navMenuComponent.ordersFormMenu && this.currentCustomer) {
                if (oldCustomer !== undefined && this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;
            case '/health-canada-spl-validation':

              if (this.navMenuComponent.hcValidationFormMenu) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {

                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/spl-upload':

              if (this.navMenuComponent.splIngestLLForm || this.navMenuComponent.splViewLLForm) {
                if (this.currentCustomer.customerId !== oldCustomer.customerId) {
                  window.location.reload();
                }
              } else {
                this.router.navigateByUrl('/accessdenied');
              }
              break;

            case '/':
            case '/home':
            case '':

              // if get to "home" after login.
              if (!oldCustomer) {

                setTimeout(() => this.router.navigate(['/order-tracker']), 200);
              } else {

                if (this.currentCustomer && this.currentCustomer.customerId !== oldCustomer.customerId) {
                  setTimeout(() => this.router.navigate(['/order-tracker']), 200);
                } else if (this.bHasOnlyOneClient) {  // this customer has only one client
                  setTimeout(() => this.router.navigate(['/order-tracker']), 200);
                }

              }
              break;
          }
        }
      });
    }
    const userguid = this.storageManagerService.read('userGuid');
    this.authenticationService.initPendo(userguid, this.selectedCustomer);
  }

  setDataScopes() {

    this.dataSource = [];

    if (this.dataSourceApi && this.dataSourceApi.length > 0) {

      this.dataSourceApi.forEach((element, i) => {
        const ds = { id: 0, name: '' };
        ds.id = i + 1;
        ds.name = element.termValueCode.toUpperCase();

        this.dataSource.push(ds);
      });

      this.navMenuComponent.dataScopes = this.dataSource;
    }
  }

  // Depending on User's access permissions, make the "Companies" and "Contacts" on the top navigation menu visible/invisible
  manageNavMenuAccess() {
    this.navMenuComponent.editCompanyMenu = this.authorizationService.hasPermission('SSDP.CanReadCompany') || this.authorizationService.hasPermission('SSDP.CanWriteCompany');

    this.navMenuComponent.editContactMenu = this.authorizationService.hasPermission('SSDP.CanReadContact') || this.authorizationService.hasPermission('SSDP.CanWriteContact');

    this.navMenuComponent.editLLFormMenu = this.authorizationService.hasPermission('SSDP.CanReadLLForm') || this.authorizationService.hasPermission('SSDP.CanWriteLLForm');

    this.navMenuComponent.editLCRFormMenu = this.authorizationService.hasPermission('SSDP.CanReadLCRForm') || this.authorizationService.hasPermission('SSDP.CanWriteLCRForm');

    this.navMenuComponent.editERFormMenu = this.authorizationService.hasPermission('SSDP.CanReadERForm') || this.authorizationService.hasPermission('SSDP.CanWriteERForm');

    this.navMenuComponent.editBusinessCategoryMenu = this.authorizationService.hasPermission('SSDP.CanReadBusinessCategory') || this.authorizationService.hasPermission('SSDP.CanWriteBusinessCategory') || this.authorizationService.hasPermission('SSDP.CanDeleteBusinessCategory');

    this.navMenuComponent.editOrdersMenu = this.authorizationService.hasPermission('SSDP.CanWriteOrder') || this.authorizationService.hasPermission('SSDP.CanCreateOrder');

    this.navMenuComponent.ordersFormMenu = this.authorizationService.hasPermission('SSDP.CanReadOrder') || this.authorizationService.hasPermission('SSDP.CanWriteOrder') || this.authorizationService.hasPermission('SSDP.CanCreateOrder') || this.authorizationService.hasPermission('SSDP.CanDeleteDraftOrder') || this.authorizationService.hasPermission('SSDP.CanCancelOrder') || this.authorizationService.hasPermission('SSDP.CanUploadDocument') || this.authorizationService.hasPermission('SSDP.CanDownloadDocument');

    this.navMenuComponent.hcValidationFormMenu = this.authorizationService.hasPermission('SSDP.CanValidateSPL-HC') || this.authorizationService.hasPermission('SSDP.CanValidateSPL-FDA');

    this.navMenuComponent.editBNCCFormMenu = this.authorizationService.hasAccessToAppVariant('SSDrugProducts-BNCC', this.currentCustomer) &&
      (this.authorizationService.hasPermission('SSDP.CanReadBlanketNoChangeForm') || this.authorizationService.hasPermission('SSDP.CanWriteBlanketNoChangeForm'))

    this.navMenuComponent.submissionMenu = this.authorizationService.hasAccessToAppVariant('SSDrugProducts-ESG', this.currentCustomer)

    this.navMenuComponent.ingestBNCC = this.authorizationService.hasAccessToAppVariant('SSDrugProducts-BNCC', this.currentCustomer) &&
      this.authorizationService.hasPermission('SSDP.CanIngestBlanketNoChangeForm')

    this.navMenuComponent.ingestPLRSPL = this.authorizationService.hasPermission('SSDP.CanIngestPLRSPLFile');

    this.navMenuComponent.substanceLookup = this.authorizationService.hasPermission('SSDP.CanValidateSubstanceLookup');
    this.navMenuComponent.splIngestLLForm = this.authorizationService.hasPermission('SSDP.CanIngestLLForm');
    this.navMenuComponent.splViewLLForm = this.authorizationService.hasPermission('SSDP.CanReadLLForm');
  }

  public onOverlayClick: EmitType<object> = () => {
    this.sessionTimeoutModal.hide();
  }

  public onContinueClicked(event) {
    this.sessionTimeoutModal.hide();
  }
  // eslint-disable-next-line @typescript-eslint/member-ordering
  dlgButtons: Object[] = [{
    click: this.onContinueClicked.bind(this), buttonModel: { content: 'Extend my session', isPrimary: true }
  }];

  private handleError(error: any) {
    console.log(error);
    return throwError(error);
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
